/**
 * Strip pasted/editor font-family so blog HTML always inherits the site font (Poppins).
 * Keeps other inline styles (color, size, alignment, etc.).
 */

const STYLE_ATTR_RE = /\sstyle\s*=\s*(["'])([\s\S]*?)\1/gi;
const FACE_ATTR_RE = /\sface\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi;
const FONT_FAMILY_DECL_RE =
  /(?:^|;)\s*(?:mso-[a-z0-9-]*)?font-family\s*:[^;]*/gi;

function cleanStyleValue(style) {
  let cleaned = String(style || "")
    .replace(FONT_FAMILY_DECL_RE, "")
    .replace(/;;+/g, ";")
    .replace(/^;+|;+$/g, "")
    .trim();
  return cleaned;
}

export function stripInlineFontFamilies(html) {
  let s = String(html || "");
  if (!s) return s;

  s = s.replace(FACE_ATTR_RE, "");
  s = s.replace(STYLE_ATTR_RE, (full, quote, style) => {
    const cleaned = cleanStyleValue(style);
    if (!cleaned) return "";
    return ` style=${quote}${cleaned}${quote}`;
  });

  return s;
}

export default stripInlineFontFamilies;
